import React, { createContext, useContext, useState, ReactNode } from "react";

export type LogoVariant =
  | "logo-01" | "logo-02" | "logo-03" | "logo-04" | "logo-05"
  | "logo-06" | "logo-07" | "logo-08" | "logo-09" | "logo-10"
  | "logo-11" | "logo-12" | "logo-13" | "logo-14" | "logo-15"
  | "logo-16" | "logo-17" | "logo-18" | "logo-19" | "logo-20"
  | "logo-21" | "logo-22" | "logo-23";

interface LogoContextType {
  variant: LogoVariant;
  setVariant: (v: LogoVariant) => void;
}

const LogoContext = createContext<LogoContextType>({
  variant: "logo-01",
  setVariant: () => {},
});

export const useLogoContext = () => useContext(LogoContext);

export const LogoProvider = ({ children }: { children: ReactNode }) => {
  const [variant, setVariant] = useState<LogoVariant>("logo-01");
  return (
    <LogoContext.Provider value={{ variant, setVariant }}>
      {children}
    </LogoContext.Provider>
  );
};
